export default {
    namespaced: true,
    state: () => ({
        passeggeri: [],
        passeggerimaggiorenni: [],
        nextpsgref : null,
    }),
    getters:{
        getPasseggeri:(state)=>{
            return state.passeggeri;
        },
        getContoPasseggeriMaggiorenni:(state)=>{
            return state.passeggerimaggiorenni.length;
        },
        getPasseggeriMaggiorenni:(state)=>{
            return state.passeggerimaggiorenni;
        },
        findPasseggeroById:(state,value)=>{
           return state.passeggeri.find(function(obj){
                return obj.id === value;
            })
        },
        findIndicePasseggeroById:(state,value)=>{
          return  state.passeggeri.map(item=>item.id).indexOf(value);
        }
    },
    mutations: {
        pulisciStato:(state)=>{
            state.passeggeri = [];
            state.passeggerimaggiorenni = [];
            state.nextpsgref = null;
        },
        aggiungiPasseggero:(state,value)=>{
            state.passeggeri.push(value);
        },
        aggiungiPasseggeriMaggiorenni:(state,value)=>{
            state.passeggerimaggiorenni.push(value);
        },
        rimuoviPasseggeroByIndice:(state,value)=>{
            state.passeggeri.splice(value,1);
        },
        setNextPsgRef:(state,value)=>{
            state.nextpsgref = value;
        }
    },
    actions: {
        commitPulisciStato:(context)=>{
            context.commit('pulisciStato');
        },
        commitAggiungiPasseggero:(context,value)=>{
            context.commit('aggiungiPasseggero',value);
        },
        commitAggiungiPasseggeriMaggiorenni:(context,value)=>{
            context.commit('aggiungiPasseggeriMaggiorenni',value);
        },
        commitSetNextPsgRef:(context,value)=>{
            context.commit('setNextPsgRef',value);
        },
        actionRimuoviPasseggeroByIndice:(context,value)=>{
            context.commit('rimuoviPasseggeroByIndice',value);
        }
    }
}